import React, { useState } from 'react';
import { LISTING_TYPE } from '../platformUtils';

import useSampleProperties from './useSampleProperties';

function useRecommendedProperties() {
    const [recommendedProperties, setRecommendedProperties] = useState(useSampleProperties(4));

    // TODO: write recommendation algorithm (backend)
    // TODO: retrieve recommendations from backend

    return recommendedProperties;
}

export default useRecommendedProperties;